


























































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import api from '../../../api/index'
import ListSelect from '../ListSelect.vue'
import CloseIcon from '../CloseIcon.vue'
import { MONTHS, DAYS, MONTH_NAMES, DAY_NAMES } from '../../constants/group'

@Component({
  components: {
    ListSelect,
    CloseIcon
  }
})
export default class GroupForm extends Vue {
  @Prop({ type: Boolean, required: true }) isActive!: boolean
  @Prop({ type: Number, required: true }) id!: number
  @Prop({ type: Array, required: true }) accessPoints!: any
  @Prop({ type: Object, default: () => ({}) }) editedGroup!: any

  hasRestrictions: boolean = false
  months = MONTHS
  days = DAYS
  monthNames = MONTH_NAMES
  dayNames = DAY_NAMES
  fields = {
    title: {
      value: '',
      check: v => v.length > 0,
      isValid: null,
      error: 'L\'intitulé doit être défini'
    },
    track_openings: {
      value: false
    },
    can_share_access: {
      value: false
    },
    access_point_ids: {
      value: [],
      check: v => v.length > 0,
      isValid: null,
      error: 'Au moins 1 boitier doit être sélectionné'
    },
    months: {
      value: [],
      isRestriction: true
    },
    days: {
      value: [],
      isRestriction: true
    },
    hour_started_at: {
      value: null,
      check: v => (v && this.fields.hour_finished_at.value) || (!v && !this.fields.hour_finished_at.value),
      isValid: null,
      error: 'Vous devez définir le début et la fin du créneau horaire',
      isRestriction: true
    },
    hour_finished_at: {
      value: null,
      isRestriction: true
    },
    started_at: {
      value: null,
      check: v => (v && this.fields.finished_at.value) || (!v && !this.fields.finished_at.value),
      isValid: null,
      error: 'Vous devez définir le début et la fin de la période',
      isRestriction: true
    },
    finished_at: {
      value: null,
      isRestriction: true
    }
  }
  fieldsDefault = Object.keys(this.fields)
    .reduce((a, v) => ({ ...a, [v]: this.fields[v].value }), {})
  errorMessage: string[] = []

  get accessPointsDictionary() {
    return this.accessPoints.reduce((a, v) => ({ ...a, [v.id]: v.title }), {})
  }

  @Watch('editedGroup', { deep: true, immediate: true })
  hydrateForm() {
    if (!this.editedGroup.id) {
      this.resetForm()
      return
    }

    this.hasRestrictions = this.editedGroup.access.restrictions_enabled;
    ['title', 'track_openings', 'can_share_access'].forEach(field => {
      this.fields[field].value = this.editedGroup[field]
    });
    ['months', 'days'].forEach(field => {
      this.fields[field].value = this.editedGroup.access.restrictions[field]
    });
    ['hour_started_at', 'hour_finished_at'].forEach(field => {
      let time = this.editedGroup.access.restrictions[field]
      let val
      if (time) {
        val = new Date()
        val.setHours(Number(time.split(':')[0]))
        val.setMinutes(Number(time.split(':')[1]))
      }
      this.fields[field].value = time ? val : time
    });
    ['started_at', 'finished_at'].forEach(field => {
      this.fields[field].value = this.editedGroup.access.restrictions[field]
        ? new Date(this.editedGroup.access.restrictions[field])
        : this.editedGroup.access.restrictions[field]
    });
    this.fields.access_point_ids.value = this.editedGroup.access_points.map(point => point.id.toString())
  }

  validateForm() {
    Object.keys(this.fields)
      .filter(field => this.fields[field].check !== undefined)
      .forEach(field => {
        this.fields[field].isValid = this.fields[field].check(this.fields[field].value)
      })
    return !Object.keys(this.fields).some(field => this.fields[field].isValid === false)
  }

  closeModal() {
    this.errorMessage = []
    this.resetForm()
    this.$emit("close");
  }

  resetForm() {
    Object.keys(this.fields).forEach(field => {
      this.fields[field].value = this.fieldsDefault[field]
      if (this.fields[field].isValid !== undefined) {
        this.fields[field].isValid = null
      }
    })
    this.hasRestrictions = false
  }

  @Watch('hasRestrictions')
  manageRestrictions() {
    if (this.hasRestrictions) return;

    Object.keys(this.fields)
      .filter(field => this.fields[field].isRestriction)
      .forEach(field => {
      this.fields[field].value = this.fieldsDefault[field]
      if (this.fields[field].isValid !== undefined) {
        this.fields[field].isValid = null
      }
    })
  }

  async createGroup() {
    this.errorMessage = []
    if (!this.validateForm()) {
      return
    }
    const group: { [key: string]: any } = {
      ...['title', 'track_openings', 'can_share_access', 'access_point_ids']
        .reduce((a, v) => ({ ...a, [v]: this.fields[v].value }), {}),
      access: {
        restrictions: {
          ...['months', 'days', 'started_at', 'finished_at']
            .reduce((a, v) => ({ ...a, [v]: this.fields[v].value }), {}),
          ...['hour_started_at', 'hour_finished_at']
            .reduce((a, v) => ({ ...a, [v]: this.formatTime(this.fields[v].value) }), {}),
        }
      }
    }
    group.access.restrictions = {
      ...group.access.restrictions,
      month_restriction: this.fields.months.value.length > 0,
      day_restriction: this.fields.days.value.length > 0,
      period_restriction: !!this.fields.started_at.value && !!this.fields.finished_at.value,
      hour_restriction: !!this.fields.hour_started_at.value && !!this.fields.hour_finished_at.value
    }
    group.access.restrictions_enabled = ['month_restriction', 'day_restriction', 'period_restriction', 'hour_restriction'].some(field => group.access.restrictions[field])
    try {
      let payload = null
      if (this.editedGroup.id) {
        await api.put(`bo/condominiums/${this.id}/groups/${this.editedGroup.id}`, {
          group,
        })
      } else {
        const res = await api.post(`bo/condominiums/${this.id}/groups`, {
          group,
        })
        payload = res.data
      }
      this.closeModal()
      this.$emit("success", payload)
    } catch (error) {
      if (error.response.status === 422) {
        error.response.data.errors.forEach(error => {
          this.errorMessage.push(error)
        })
        return
      }
      this.errorMessage.push('Une erreur s\'est produite')
    }
  }
  formatTime(time) {
    return time
      ? ['getHours', 'getMinutes'].map(fn => {
        const r = time[fn]()
        return r > 9 ? r : `0${r}`
      }).join(':')
      : time
  }
}
